import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useCartorio } from "../Hooks/cartorio";
import { useFuncionarioCartorio } from "../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../Hooks/funcionarioPrefeitura";
import { useImovel } from "../Hooks/imoveis";
import { usePrefeitura } from "../Hooks/usePrefeitura";
import api from "../Services/api";
import { isRural } from "../Utils/isRural";

// Defina suas interfaces aqui
export interface ITransmitente {
  ID: string;
  NOME: string;
  RUA: string;
  NUMERO: number;
  BAIRRO: string;
  COMPLEMENTO: string;
  IMOVEL_ID: number;
  IMOVEL_RURAL_ID: number;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  CPF: string;
  CNPJ: string;
  MUNICIPIO: string;
  UF: string;
}

interface ITransmitenteContextData {
  transmitentes: ITransmitente[];
  setTransmitentes: React.Dispatch<React.SetStateAction<ITransmitente[]>>;
  getTransmitentes: () => Promise<void>;
  excluir: (id: number) => Promise<void>;
}

interface ITransmitenteProviderProps {
  children: ReactNode;
}

// Crie o contexto
const TransmitenteContext = createContext({} as ITransmitenteContextData);

// Componente provedor
function TransmitenteProvider({ children }: ITransmitenteProviderProps) {
  const { funcionarioCartorioIsLogged } = useFuncionarioCartorio();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  const { cartorioIsLogged } = useCartorio();
  const { prefeituraIsLogged } = usePrefeitura();

  const { imovelFocus } = useImovel();

  const [transmitentes, setTransmitentes] = useState([] as ITransmitente[]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // if (
    //   funcionarioCartorioIsLogged ||
    //   funcionarioPrefeituraIsLogged ||
    //   prefeituraIsLogged ||
    //   cartorioIsLogged
    // ) {
    // }
   
    getTransmitentes();
  }, [
    imovelFocus,
    funcionarioCartorioIsLogged,
    funcionarioPrefeituraIsLogged,
    prefeituraIsLogged,
    cartorioIsLogged,
  ]);

  async function getTransmitentes() {
    try {
      setLoading(true);
    
      if (imovelFocus.ID) {
        const { data } = isRural()
          ? await api.get(`/transmitente-rural/${imovelFocus.ID}`)
          : await api.get(`/transmitente/${imovelFocus.ID}`);
        
       
        setTransmitentes(data);
      }
    } catch (e) {
      // window.alert(JSON.stringify(e))
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  async function excluir(id: number) {
    try {
      const { data } = await api.delete(`/transmitente/${id}`);
      getTransmitentes();
    } catch (e) {
      // window.alert(JSON.stringify(e))
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  // Defina suas funções aqui

  useEffect(() => {
    // Lógica de efeito colateral aqui
  }, []);

  return (
    <TransmitenteContext.Provider
      value={{
        // Valores de contexto aqui
        transmitentes,
        setTransmitentes,
        getTransmitentes,
        excluir,
      }}
    >
      {children}
    </TransmitenteContext.Provider>
  );
}

// Hook personalizado
function useTransmitente() {
  const context = useContext(TransmitenteContext);

  if (!context) {
    throw new Error(
      "useTransmitente must be used within a TransmitenteProvider"
    );
  }

  return context;
}

export { TransmitenteProvider, useTransmitente };
